// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"77":"ce7cff02","92":"a5e28c8c","312":"27772127","321":"5f964574","471":"913a85b6","591":"bb35267c","828":"58c2d70d"}[chunkId] + ".chunk.js";
};